import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import add from "../../Assets/Image/admin/add.png";
import {
  addCategoryContact,
  deleteCategoryContact,
  updateCategory,
  getCategoryList,
} from "../../Services/ApiServices";
import { Circles } from "react-loader-spinner";
import { LIST_LANGUAGES_API } from "../../Services/Api";
import Dialog from "../../Base-Component/Dialog/Dialog";
import axios from "axios";
import back from "../../Assets/Image/admin/back.png";
import { PenLine, Trash2 } from "lucide-react";

function ContactInfo() {
  const navigate = useNavigate();
  const location = useLocation();
  const roleData = JSON.parse(localStorage.getItem("e-learn-data"));
  const [contactModel, setContactModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [campaignId, setCampaignId] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [brandName, setBrandName] = useState("");
  const [formValue, setFormValue] = useState({});
  const [listLanguages, setListLanguages] = useState([]);

  const [searchEmail, setSearchEmail] = useState("");
  const [searchCountry, setSearchCountry] = useState("");
  const [searchLanguage, setSearchLanguage] = useState("");

  const datas = location.state.Data || {};
  console.log("data >>", datas);

  const [contactList, setContactList] = useState(datas.category_contacts || []);

  const displayedContacts = contactList.filter((item) => {
    if (searchLanguage) {
      return String(item.language_id) === String(searchLanguage);
    }
    return true;
  });

  const fetchCategoryContacts = () => {
    let obj = {
      category_id: datas.id,
      email: searchEmail || undefined,
      country: searchCountry || undefined,
      language_id: searchLanguage || undefined,
    };
    getCategoryList(obj)
      .then((res) => {
        const categories = res.data.data || [];
        const currentCategory = categories.find(
          (cat) => String(cat.id) === String(datas.id)
        );
        if (currentCategory) {
          setContactList(currentCategory.category_contacts || []);
        } else {
          setContactList([]);
        }
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
      });
  };

  useEffect(() => {
    handleLanguages();
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchCategoryContacts();
    }, 400);

    return () => clearTimeout(delayDebounceFn);
  }, [searchEmail, searchCountry, searchLanguage]);

  const handleLanguages = () => {
    axios
      .get(LIST_LANGUAGES_API)
      .then((res) => {
        const data = res.data.islanguage;
        setListLanguages(data);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
      });
  };

  const handleAddContactInfo = (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (isUpdate) {
      const params = {
        contact_id: formValue.id,
        category_id: datas.id,
        language_id: formValue.language_id,
        name: formValue.name,
        email: formValue.email,
        phone_number: formValue.phone_number,
        country: formValue.country,
      };

      updateCategory(params)
        .then((res) => {
          toast.success(res.data.message);
          setIsLoading(false);
          navigate("/brand");
        })
        .catch((err) => {
          if (err?.response?.status == 401) {
            Cookies.remove("e_learning_token");
            navigate("/login");
          } else {
            toast.error(err.response.data.message);
          }
          setIsLoading(false);
        });
    } else {
      const params = {
        category_id: datas.id,
        language_id: formValue.language_id,
        name: formValue.name,
        email: formValue.email,
        phone_number: formValue.phone_number,
        country: formValue.country,
      };

      addCategoryContact(params)
        .then((res) => {
          toast.success(res.data.message);
          setIsLoading(false);
          navigate("/brand");
        })
        .catch((err) => {
          if (err?.response?.status == 401) {
            Cookies.remove("e_learning_token");
            navigate("/login");
          } else {
            toast.error(err.response.data.message);
          }
          setIsLoading(false);
        });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleDeleteView = (id) => {
    setIsDelete(true);
    setCampaignId(id);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let obj = {
      id: campaignId,
    };

    deleteCategoryContact(obj)
      .then((res) => {
        toast.success(res.data.message);
        navigate("/brand");
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setIsLoading(false);
      });
  };

  const handleEdit = (data) => {
    setIsUpdate(true);
    handleLanguages();
    setFormValue(data);
    setIsLoading(false);
    setContactModel(true);
  };

  const handleAddContact = () => {
    setContactModel(true);
    handleLanguages();
    setBrandName(datas.category_name);
    setIsUpdate(false);
  };

  return (
    <div className="md:m-4 m-1 fontNew">
      <div className="flex flex-wrap items-center justify-between mb-7 gap-4">
        <div className="flex items-center cursor-pointer">
          <img
            src={back}
            onClick={() => {
              navigate("/brand");
            }}
            className="w-4"
            alt=""
          />
          <p
            onClick={() => {
              navigate("/brand");
            }}
            className="text-base font-medium ms-3 p-0"
          >
            Go back
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-3 w-full lg:w-auto justify-end">
          <div className="xl:w-52 sm:w-36 w-full h-10 px-4 rounded-lg bg-white flex items-center shadow-sm">
            <input
              type="text"
              className="bg-transparent w-full border-none outline-none h-10 text-sm fontNew"
              placeholder="Email..."
              value={searchEmail}
              onChange={(e) => setSearchEmail(e.target.value)}
            />
          </div>
          <div className="xl:w-52 sm:w-36 w-full h-10 px-4 rounded-lg bg-white flex items-center shadow-sm">
            <input
              type="text"
              className="bg-transparent w-full border-none outline-none h-10 text-sm fontNew"
              placeholder="Country..."
              value={searchCountry}
              onChange={(e) => setSearchCountry(e.target.value)}
            />
          </div>
          <div className="xl:w-52 sm:w-36 w-full">
            <select
              value={searchLanguage}
              onChange={(e) => setSearchLanguage(e.target.value)}
              className="px-4 select-arrow-hidden text-sm rounded-lg font-medium w-full h-10 outline-none bg-white shadow-sm fontNew"
            >
              <option value="">All Languages</option>
              {listLanguages.map((item, index) => (
                <option key={index} value={item.id}>
                  {item.Language_name}
                </option>
              ))}
            </select>
          </div>
          {/* {roleData?.role !== "sub_admin" && ( */}
          <div>
            <button
              onClick={handleAddContact}
              className="bg-[#e29c29] text-white flex items-center py-2 px-3 rounded-lg whitespace-nowrap h-10 shadow-sm"
            >
              <img src={add} className="w-6 mr-2" alt="" />
              Add Contact
            </button>
          </div>
          {/* )} */}
        </div>
      </div>

      <div className="my-4 flex justify-center">
        <h4 className="text-2xl font-semibold underline capitalize tracking-wider font-medium">
          {datas.category_name || ""}
        </h4>
      </div>

      <div className="grid grid-cols-12 gap-4">
        {displayedContacts.length === 0 ? (
          <div className="col-span-12 flex items-center justify-center h-[60vh]">
            No Data Found
          </div>
        ) : (
          <>
            {displayedContacts.map((item, index) => {
              return (
                <div
                  key={index}
                  className="2xl:col-span-3 md:col-span-4 sm:col-span-6 col-span-12 bg-white p-4 rounded-[14px] space-y-2"
                >
                  <p>
                    <span className="font-medium">Name :</span>{" "}
                    {item.name || ""}
                  </p>
                  <p>
                    <span className="font-medium">Email :</span>{" "}
                    {item.email || ""}
                  </p>
                  <p>
                    <span className="font-medium">Country :</span>{" "}
                    {item.country || ""}
                  </p>
                  <p>
                    <span className="font-medium">Phone Num. :</span>{" "}
                    {item.phone_number || ""}
                  </p>
                  <div className="border-t my-4"></div>
                  <div className="flex text-sm justify-end items-center gap-4">
                    <p
                      onClick={() => handleDeleteView(item.id)}
                      className="flex items-center font-medium text-[#e43232] cursor-pointer"
                    >
                      <Trash2 color="#e43232" size={17} className="mr-1" />{" "}
                      Delete
                    </p>
                    {roleData?.role !== "sub_admin" && (
                      <p
                        onClick={() => handleEdit(item)}
                        className="flex items-center font-medium text-[#000cff] cursor-pointer"
                      >
                        <PenLine color="#000cff" size={17} className="mr-1" />{" "}
                        Edit
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>

      <Dialog
        open={contactModel}
        onClose={() => {
          setContactModel(false);
          setFormValue({});
        }}
        size="md"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="p-4 sm:w-auto w-[330px] sm:h-auto h-[500px] overflow-auto fontNew">
              <h4 className="text-lg font-semibold mb-2">
                <span className="capitalize">{brandName}</span> Contact Info
              </h4>
              <form onSubmit={handleAddContactInfo}>
                <div className="grid grid-cols-12 ">
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">
                      Select Language
                    </h4>
                    <select
                      name="language_id"
                      required
                      value={formValue.language_id || ""}
                      onChange={handleChange}
                      className="select-arrow-hidden w-full outline-[#e1c595] border-2 px-4 py-3 rounded-md"
                    >
                      <option label="Select Language"></option>
                      {listLanguages.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {item.Language_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">Name</h4>
                    <input
                      type="text"
                      name="name"
                      required
                      value={formValue.name || ""}
                      onChange={handleChange}
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">Email</h4>
                    <input
                      type="email"
                      name="email"
                      required
                      value={formValue.email || ""}
                      onChange={handleChange}
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">Phone No :</h4>
                    <input
                      type="number"
                      name="phone_number"
                      required
                      value={formValue.phone_number || ""}
                      onChange={handleChange}
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    //   minLength={12}
                    />
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">Country</h4>
                    <input
                      type="text"
                      name="country"
                      required
                      value={formValue.country || ""}
                      onChange={handleChange}
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                </div>
                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    onClick={() => {
                      setContactModel(false);
                      setFormValue({});
                    }}
                    className="bg-[#EF5F5F] py-2 px-7 text-white rounded-lg mr-5"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="bg-[#00987C] text-white h-[45px] w-30 rounded-lg"
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      <span>{isUpdate === true ? "Update" : "Add"}</span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog open={isDelete} onClose={() => setIsDelete(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center text-center my-4 sm:px-16 px-4 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Delete Contact?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you sure you want to delete this Contact Info?
                </p>
                <div className="mt-13 flex items-center mb-5">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsDelete(false)}
                  >
                    Close
                  </button>
                  <button
                    disabled={isLoading}
                    className="bg-[#e29c29] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={handleDelete}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "Yes, Delete"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
}

export default ContactInfo;
